import { useNavigate, useParams } from 'react-router';
import { ArrowLeft, CalendarDays, Trophy } from 'lucide-react';
import PlayerLiquidNavigation, { playerNavigationBase } from './components/PlayerLiquidNavigation';

export default function PlayerComingSoonPage({ section }) {
  const navigate = useNavigate();
  const { tenantSlug } = useParams();
  const title = section === 'events' ? 'Events' : 'Achievements';
  const Icon = section === 'events' ? CalendarDays : Trophy;
  const goHome = () => navigate(playerNavigationBase(tenantSlug));
  return <div className="player-app player-coming-soon" data-testid={`player-${section}-coming-soon`}>
    <header className="player-coming-soon__header">
      <button type="button" aria-label="Back to Home" onClick={goHome}><ArrowLeft size={22} /></button>
      <h1 className="display">{title}</h1>
    </header>
    <main className="player-coming-soon__content">
      <Icon size={48} strokeWidth={1.5} aria-hidden="true" />
      <h2 className="display">This feature will be live soon.</h2>
      <p>We’re getting {title.toLowerCase()} ready for you. Please check back later.</p>
      <button type="button" onClick={goHome}>Back to Home</button>
    </main>
    <PlayerLiquidNavigation active={section} />
  </div>;
}
